import * as type from "../consts";
import PoolData from "../../../pages/Auth/AWSConfig/PoolData";
import axios from "axios";
import { axiosErrorHandler } from "../../../utility/action-helper";
import {
  OTP_SEND_CODE_ERROR,
  OTP_SEND_CODE_REQUEST,
  OTP_SEND_CODE_SUCCESS,
  OTP_VERIFY_CODE_ERROR,
  OTP_VERIFY_CODE_REQUEST,
  OTP_VERIFY_CODE_SUCCESS,
  RECAPTCHA_ERROR,
  RECAPTCHA_REQUEST,
  RECAPTCHA_SUCCESS,
} from "../consts";
import { formatTelegramLog } from "../../../utility/formatter-helper";
import {
  clearLocalStorage,
  getCacheData,
  saveCacheData,
} from "../../../utility/helper";

export const setToken = (data) => (dispatch) => {
  dispatch({
    type: type.SET_TOKEN,
    payload: data,
  });
};

export const setRefreshToken = (data) => (dispatch) => {
  localStorage.setItem("REFRESH_TOKEN", data);
  dispatch({
    type: type.SET_REFRESH_TOKEN,
    payload: data,
  });
};

export const setSystemData = (data) => (dispatch) => {
  localStorage.setItem("SYSTEM_DATA", JSON.stringify(data));
  dispatch({
    type: type.SET_SYSTEM_DATA,
    payload: data,
  });
};

export const setUserData = (data) => (dispatch) => {
  // console.log(data);
  localStorage.setItem("aws-amplify-USERDATA", JSON.stringify(data));
  dispatch({
    type: type.SET_USERDATA,
    payload: data,
  });
};

export const setAuthData = (userData, token, refreshToken) => (dispatch) => {
  localStorage.setItem("aws-amplify-USERDATA", JSON.stringify(userData));
  localStorage.setItem(
    "aws-amplify-federatedInfo",
    JSON.stringify({ token: token }),
  );
  if (refreshToken) {
    localStorage.setItem("refreshToken", refreshToken);
  }

  let payload = { userData, token };

  if (refreshToken) {
    payload.refreshToken = refreshToken;
  }

  dispatch({ type: "SET_AUTH_DATA", payload });
};

export const setDataAsLocal = () => (dispatch) => {
  dispatch({
    type: type.SET_DATA_AS_LOCAL,
    payload: {
      token: localStorage.getItem("TOKEN"),

      systemData: JSON.parse(localStorage.getItem("SYSTEM_DATA")),

      userData: JSON.parse(localStorage.getItem("USER_DATA")),
    },
  });
};

export const setLogout = () => (dispatch) => {
  // localStorage.setItem("lastLogout", JSON.stringify(new Date()));
  // localStorage.removeItem("aws-amplify-federatedInfo");
  // localStorage.removeItem("aws-amplify-USERDATA");
  let seeNotificationWarning;
  if (localStorage.getItem("seeNotificationWarning")) {
    seeNotificationWarning = localStorage.getItem("seeNotificationWarning");
  }

  clearLocalStorage();

  localStorage.setItem("lastLogout", JSON.stringify(new Date()));

  localStorage.setItem("seeNotificationWarning", seeNotificationWarning);
  // dispatch(setLogout());
  const user = PoolData.getCurrentUser();
  user?.signOut();
  window.location.href = "/auth/login";
  window.location.reload();
  dispatch({
    type: type.SET_LOGOUT,
    payload: new Date(),
  });
};

export const saveUserPass = (data) => {
  return { type: type.SAVE_USER_PASS, payload: data };
};

export const setLoginProcessToTelegram = () => {
  // "set-login-process-to-telegram"
  return { type: "set-login-process-to-telegram" };
};

export const signinUpMiniApp =
  (
    telegram_id,
    user,
    email,
    retryCount = 0,
    currentPath = window?.location?.href,
  ) =>
  async (dispatch) => {
    dispatch({ type: "signin_up_mini_app_request" });

    const url =
      "https://0znr1xesf9.execute-api.ap-southeast-2.amazonaws.com/dev/api";
    const data = {
      operation_mode: "signin_up_miniapp",
      telegram_id,
      user,
      email,
    };

    await axios
      .post(url, data)
      .then((res) => {
        console.log(res);
        dispatch({ type: "signin_up_mini_app_success" });
      })
      .catch((err) => {
        axiosErrorHandler(
          err,
          retryCount,
          dispatch,
          () => signinUpMiniApp(telegram_id, user, email, retryCount + 1),
          "signin_up_mini_app_error",
          user,
          email,
          formatTelegramLog("signin_up_miniapp", data, url),
          0,
          currentPath,
        );
      });
  };
export const saveTelegramAuthData = (data) => (dispatch) => {
  const telegramId = data.slice(0, 20);
  const userName = data.slice(20, 25);
  const email = data.slice(25, 30);
  const next = data.slice(-5);
  const payload = {
    telegramId,
    userName,
    email,
    next,
  };

  localStorage.setItem("telegramAuthData", JSON.stringify(payload));
  dispatch({ type: "save-telegram-data", payload });
};

export const sendOtpVerificationCode =
  (email, retryCount = 0, currentPath = window?.location?.href) =>
  async (dispatch) => {
    dispatch({ type: OTP_SEND_CODE_REQUEST });

    const url =
      "https://weu658vyjj.execute-api.ap-southeast-2.amazonaws.com/dev/api";
    const data = {
      operation_mode: "send_verification_code",
      email,
    };

    await axios
      .post(url, data)
      .then((res) => {
        console.log(res);
        dispatch({ type: OTP_SEND_CODE_SUCCESS, payload: res?.data?.message });
      })
      .catch((err) => {
        console.log(err);
        axiosErrorHandler(
          err,
          retryCount,
          dispatch,
          () => sendOtpVerificationCode(email, retryCount + 1),
          OTP_SEND_CODE_ERROR,
          "user",
          email,
          formatTelegramLog("send_verification_code", data, url),
          0,
          currentPath,
        );
      });
  };

export const verifyOtpCode =
  (email, verification_code, retryCount = 0) =>
  async (dispatch) => {
    dispatch({ type: OTP_VERIFY_CODE_REQUEST });

    await axios
      .post(
        "https://weu658vyjj.execute-api.ap-southeast-2.amazonaws.com/dev/api",
        {
          operation_mode: "verify_verification_code",
          email,
          verification_code,
        },
      )
      .then((res) => {
        console.log(res);
        dispatch({
          type: OTP_VERIFY_CODE_SUCCESS,
          payload: res?.data,
        });
        // dispatch(setToken(res?.data?.accessToken?.jwtToken));
        // dispatch(setUserData(formatUserData(res?.data?.accessToken?.payload)));
      })
      .catch((err) => {
        console.log(err);
        axiosErrorHandler(
          err,
          retryCount,
          dispatch,
          () => sendOtpVerificationCode(email, retryCount + 1),
          OTP_VERIFY_CODE_ERROR,
          "user",
          email,
          "verify_verification_code",
        );
      });
  };

export const getRecaptcha =
  (retryCount = 0, currentPath = window?.location?.href) =>
  async (dispatch) => {
    dispatch({ type: RECAPTCHA_REQUEST });

    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    const url =
      "https://5i8nm5c656.execute-api.ap-southeast-2.amazonaws.com/dev/generate-captcha";

    try {
      const response = await axios.get(url, config);
      // console.log(response.data);
      dispatch({ type: RECAPTCHA_SUCCESS, payload: response.data });
      localStorage.setItem("recAnswer", response?.data?.answer);
    } catch (error) {
      if (error?.code === "ERR_NETWORK") {
        dispatch({ type: RECAPTCHA_ERROR });
      }
      // console.log(error);
      axiosErrorHandler(
        error,
        retryCount,
        dispatch,
        () => getRecaptcha(retryCount + 1),
        RECAPTCHA_ERROR,
        "user",
        "email",
        formatTelegramLog("get_recaptcha", config, url),
        0,
        currentPath,
      );
      // dispatch({ type: RECAPTCHA_ERROR, payload: error.message });
    }
  };

export const generateTextCaptcha =
  (
    difficulty_level = "medium",
    retryCount = 0,
    currentPath = window?.location?.href,
  ) =>
  async (dispatch) => {
    dispatch({ type: "GENERATE_TEXT_CAPTCHA_REQUEST" });

    const url = `https://5i8nm5c656.execute-api.ap-southeast-2.amazonaws.com/dev/generate-captcha?type=text`;

    const config = {
      type: "text",
    };

    await axios
      .get(url)
      .then((res) => {
        // console.log(res);
        dispatch({ type: "GENERATE_TEXT_CAPTCHA_SUCCESS", payload: res.data });
      })
      .catch((err) => {
        if (err?.code === "ERR_NETWORK") {
          dispatch({
            type: "GENERATE_TEXT_CAPTCHA_ERROR",
            payload: err.message || err.MESSAGE,
          });
        } else {
          axiosErrorHandler(
            err,
            retryCount,
            dispatch,
            () =>
              generateTextCaptcha(
                difficulty_level,
                retryCount + 1,
                currentPath,
              ),
            "GENERATE_TEXT_CAPTCHA_ERROR",
            "user",
            "email",
            formatTelegramLog("generate-captcha", config, url),
            0,
            currentPath,
          );
        }
      });
  };

export const generateImageCaptcha =
  (
    difficulty_level = "medium",
    retryCount = 0,
    currentPath = window?.location?.href,
  ) =>
  async (dispatch) => {
    dispatch({ type: "GENERATE_IMAGE_CAPTCHA_REQUEST" });

    const url = `https://5i8nm5c656.execute-api.ap-southeast-2.amazonaws.com/dev/generate-captcha?type=image`;

    const config = {
      type: "image",
    };

    await axios
      .get(url)
      .then((res) => {
        // console.log(res);
        dispatch({ type: "GENERATE_IMAGE_CAPTCHA_SUCCESS", payload: res.data });
      })
      .catch((err) => {
        if (err?.code === "ERR_NETWORK") {
          dispatch({
            type: "GENERATE_IMAGE_CAPTCHA_ERROR",
            payload: err.message || err.MESSAGE,
          });
        } else {
          axiosErrorHandler(
            err,
            retryCount,
            dispatch,
            () =>
              generateImageCaptcha(
                difficulty_level,
                retryCount + 1,
                currentPath,
              ),
            "GENERATE_IMAGE_CAPTCHA_ERROR",
            "user",
            "email",
            formatTelegramLog("generate-captcha", config, url),
            0,
            currentPath,
          );
        }
      });
  };
